import { useEffect, useState } from "react";
import { useAuth } from "../auth/AuthProvider";
import { verifyGeoAssets } from "../lib/assets";
import "./data-status.css";

type Status =
  | { kind: "checking" }
  | { kind: "ready"; count: number; version: string }
  | { kind: "error" };

export function DataStatus() {
  const { session } = useAuth();
  const [status, setStatus] = useState<Status>({ kind: "checking" });

  useEffect(() => {
    if (!session?.access_token) return;
    const controller = new AbortController();
    setStatus({ kind: "checking" });

    verifyGeoAssets(session.access_token, controller.signal)
      .then((result) => {
        setStatus({ kind: "ready", count: result.artifactCount, version: result.version });
      })
      .catch((error: unknown) => {
        if (error instanceof DOMException && error.name === "AbortError") return;
        setStatus({ kind: "error" });
      });

    return () => controller.abort();
  }, [session?.access_token]);

  if (status.kind === "ready") {
    return (
      <p className="data-status data-status-ready" role="status">
        <span aria-hidden="true" className="data-status-dot" />
        {status.count} productos conectados · versión {status.version}
      </p>
    );
  }

  if (status.kind === "error") {
    return (
      <p className="data-status data-status-error" role="alert">
        <span aria-hidden="true" className="data-status-dot" />
        No fue posible verificar los productos geoespaciales.
      </p>
    );
  }

  return (
    <p className="data-status" role="status">
      <span aria-hidden="true" className="data-status-dot" />
      Verificando productos geoespaciales…
    </p>
  );
}
